import { webMCPRegistry } from './registry';
import { WebMCPToolDefinition } from '../types/webmcp';

export function scanAndRegisterDeclarativeTools(): void {
  if (typeof document === 'undefined') return;

  const forms = document.querySelectorAll<HTMLFormElement>('form[toolname]');

  forms.forEach((form) => {
    const name = form.getAttribute('toolname');
    const description = form.getAttribute('tooldescription') || 'Declarative HTML Form Tool';

    if (!name) return;

    // Check if already registered
    if (webMCPRegistry.getTool(name)) return;

    // Build JSON Schema from input fields inside the form
    const properties: Record<string, any> = {};
    const required: string[] = [];

    const inputs = form.querySelectorAll<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>(
      'input, select, textarea'
    );

    inputs.forEach((input) => {
      const fieldName = input.name || input.id;
      if (!fieldName) return;

      properties[fieldName] = {
        type: input.type === 'number' ? 'number' : 'string',
        description: input.getAttribute('placeholder') || `Form field ${fieldName}`,
      };

      if (input.required) {
        required.push(fieldName);
      }
    });

    const declarativeTool: WebMCPToolDefinition = {
      name,
      description: `[Declarative Form Tool] ${description}`,
      inputSchema: {
        type: 'object',
        properties,
        required,
      },
      execute: async (data: Record<string, any>) => {
        console.log(`[WebMCP Declarative] Executing form tool '${name}':`, data);

        // Populate fields in DOM
        Object.entries(data).forEach(([key, val]) => {
          const field = form.querySelector<HTMLInputElement>(`[name="${key}"], #${key}`);
          if (field) {
            field.value = String(val);
            field.dispatchEvent(new Event('input', { bubbles: true }));
            field.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });

        // Submit form
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));

        return {
          status: 'submitted',
          form: name,
          fieldsUpdated: Object.keys(data),
          timestamp: Date.now(),
        };
      },
    };

    webMCPRegistry.register(declarativeTool);
    console.log(`[WebMCP Declarative] Registered form tool '${name}'`);
  });
}
